import { MutationHookOptions } from '@apollo/client'
import {
  MySessionsDataTableDocument,
  SessionAccessMembershipsDataTableDocument,
  TrainingSessionsByEmployeeDataTableDocument,
} from 'generated/resources/datatable.graphql'
import {
  UpdateSessionAttendancesDocument,
  UpdateSessionAttendancesMutation,
  UpdateSessionAttendancesMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

type Options = MutationHookOptions<
  UpdateSessionAttendancesMutation,
  UpdateSessionAttendancesMutationVariables
>

export const useUpdateSessionAttendances = (options?: Options) => {
  const [updateSessionAttendances, { loading }] = useMutation(UpdateSessionAttendancesDocument, {
    ...options,
    extractorFn: (data) => data.trainingsMutations.bulkUpdateTrainingsSessionAttendance,
  })

  return {
    loading,
    updateSessionAttendances(variables: UpdateSessionAttendancesMutationVariables) {
      return updateSessionAttendances({
        variables,
        awaitRefetchQueries: true,
        refetchQueries: [
          SessionAccessMembershipsDataTableDocument,
          MySessionsDataTableDocument,
          TrainingSessionsByEmployeeDataTableDocument,
        ],
      })
    },
  }
}
